document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.product-tabs .tabs a');
  const tabContents = document.querySelectorAll('.product-tabs .tabs-content li');

  function checkAndHideEmptyTabs() {
    tabContents.forEach(function (content) {
      if (content.textContent.trim() === '' || content.style.display === 'none') {
        content.style.display = 'none';
        const tabId = content.getAttribute('id');
        tabs.forEach(function (tab) {
          if (tab.getAttribute('href').substring(1) === tabId) {
            tab.parentElement.style.display = 'none';
          }
        });
      }
    });
  }

  function checkAndHideEmptyAccordion() {
    const accordionHeaders = document.querySelectorAll('.product-tabs .tab-accordion');
    accordionHeaders.forEach(function (header) {
      const panel = header.nextElementSibling;
      if (!panel || panel.textContent.trim() === '') {
        header.style.display = 'none';
        if (panel) {
          panel.style.display = 'none';
        }
      }
    });
  }

  checkAndHideEmptyTabs();
  checkAndHideEmptyAccordion();

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function (event) {
      event.preventDefault();

      tabs.forEach(function (t) {
        t.classList.remove('active');
      });

      tabContents.forEach(function (content) {
        content.classList.remove('active');
      });

      tab.classList.add('active');

      const tabId = tab.getAttribute('href').substring(1);
      const tabContent = document.getElementById(tabId);
      if (tabContent) {
        tabContent.classList.add('active');
        tabContent.style.display = '';
      }

      tabContents.forEach(function (content) {
        if (content.textContent.trim() === '' || content.style.display === 'none') {
          content.style.display = 'none';
          const contentId = content.getAttribute('id');
          tabs.forEach(function (t) {
            if (t.getAttribute('href').substring(1) === contentId) {
              t.parentElement.style.display = 'none';
            }
          });
        }
      });
    });
  });

  const accTab = document.querySelectorAll('.product-tabs .tab-accordion');

  function togglePanel(event) {
    const panel = event.target.nextElementSibling;
    if (panel.classList.contains('show')) {
      panel.classList.remove('show');
      event.target.classList.remove('active');
    } else {
      panel.classList.add('show');
      event.target.classList.add('active');
    }
  }

  function setupAccordions() {
    if (window.innerWidth < 1024) {
      for (let i = 0; i < accTab.length; i++) {
        if (i === 0 && !document.querySelector('.product-tabs .tab-accordion.active')) {
          accTab[i].nextElementSibling.classList.add('show');
          accTab[i].classList.add('active');
        }
        accTab[i].addEventListener('click', togglePanel);
      }
    }
  }

  setupAccordions();

  window.addEventListener('resize', function () {
    const activeAccordions = [];
    for (let i = 0; i < accTab.length; i++) {
      if (accTab[i].classList.contains('active')) {
        activeAccordions.push(i);
      }
      accTab[i].removeEventListener('click', togglePanel);
    }

    for (let i = 0; i < accTab.length; i++) {
      accTab[i].classList.remove('active');
      accTab[i].nextElementSibling.classList.remove('show');
    }

    setupAccordions();

    if (window.innerWidth < 1024) {
      activeAccordions.forEach(function (index) {
        if (accTab[index]) {
          accTab[index].classList.add('active');
          accTab[index].nextElementSibling.classList.add('show');
        }
      });
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.closest('.product-tabs-mobile')) {
      setTimeout(function () {
        setupAccordions();
      }, 100);
    }
  });
});
